import _ from "lodash";
import React from "react";
import classes from "./AIPanelHeader.scss";
import { CloseOutlined, RefreshArrowOutlined } from "@toddle-edu/ds-icons";
import { IconButton, Tooltip } from "@toddle-edu/ds-web";
import { useTranslation } from "react-i18next";

/**
 * @description
 * AIPanelHeader Component
 * AIPanelHeader component renders the header of the AI panel.
 * It includes a title and a close button to hide the panel.
 */
const AIPanelHeader = props => {
  const { t } = useTranslation();
  const {
    title = "",
    testId = "",
    sendEvent = _.noop,
    showClearChat = false,
  } = props;

  return (
    <div className={classes.aiPanelHeader}>
      <h6>{title}</h6>

      <div className={classes.aiPanelHeaderRightContainer}>
        {showClearChat && (
          <Tooltip
            tooltip={t("common:clear_chat_history")}
            placement="bottom"
            showArrow={true}
          >
            <IconButton
              type="plain"
              dsVersion="2.0"
              variant="neutral"
              testId={`${testId}-clearChatButton`}
              onClick={() => sendEvent("CLEAR_CHAT")}
              icon={<RefreshArrowOutlined variant="neutral" />}
            />
          </Tooltip>
        )}

        <IconButton
          type="plain"
          dsVersion="2.0"
          variant="neutral"
          testId={`${testId}-closePanelButton`}
          onClick={() => sendEvent("CLOSE_PANEL")}
          icon={<CloseOutlined variant="neutral" />}
        />
      </div>
    </div>
  );
};

export default AIPanelHeader;
